export const companiesCompanyIdCustomDomainsLimits = "/companies/:company_id/custom_domains/limits";
